/** German client fallbacks for the active Support Inbox.
 * Database translations remain authoritative and override these values. */
export const SUPPORT_INBOX_DE_FALLBACK: Record<string, string> = {
  "support.activity.error": "Teamaktivität konnte nicht geladen werden",
  "support.activity.noted": "hat eine interne Notiz hinzugefügt",
  "support.activity.replied": "hat geantwortet",
  "support.activity.title": "Teamaktivität",
  "support.ai.changeDraft": "Was soll die KI am Entwurf ändern?",
  "support.ai.draft": "KI-Entwurf",
  "support.ai.draftChanged":
    "Dein Entwurf wurde inzwischen geändert. Bitte erneut anwenden.",
  "support.ai.drafting": "Formuliert …",
  "support.ai.failed":
    "KI-Entwurf konnte nicht erstellt werden. Dein Text bleibt erhalten.",
  "support.ai.instruction": "Anweisung für KI",
  "support.ai.noReply": "Für diese Nachricht wird keine Antwort empfohlen.",
  "support.ai.tooLong": "Entwurf und Anweisung sind zu lang. Bitte kürzen.",
  "support.ai.writePrompt":
    "Was soll die KI schreiben? z. B. „Techniker kommt morgen früh“",
  "support.aiAction.dismiss": "Ignorieren",
  "support.attachments.invalid":
    "Dateien müssen einem erlaubten Typ entsprechen und dürfen höchstens 10 MB groß sein.",
  "support.bundle.count": "{count} Meldungen gebündelt",
  "support.bundle.detail":
    "gleiches Problem im selben Objekt. Auch von {names}. Antworten und Aufträge gehen an alle.",
  "support.bundle.separate": "Trennen",
  "support.channel.email": "E-Mail",
  "support.composer.backToReply": "Zurück zur Antwort",
  "support.composer.from": "von",
  "support.composer.signature": "Signatur",
  "support.composer.via": "via",
  "support.composer.writeReply": "Antwort schreiben",
  "support.contact.external": "Extern",
  "support.contact.owner": "Eigentümer",
  "support.contact.tenant": "Mieter",
  "support.detail.assigned": "Zuständig:",
  "support.detail.assignedNotified":
    "{name} ist jetzt zuständig und wurde benachrichtigt",
  "support.detail.conversation": "Unterhaltung",
  "support.detail.doneNext": "Erledigt · weiter: {name}",
  "support.detail.previousCase": "{count} früherer Fall",
  "support.detail.previousCases": "{count} frühere Fälle",
  "support.detail.statusUpdateSuccess": "Status aktualisiert",
  "support.folder.mine": "Dir zugewiesen",
  "support.list.assign": "Zuweisen",
  "support.list.assignTo": "Weitergeben an …",
  "support.list.bulkCompleteFailed":
    "Tickets konnten nicht abgeschlossen werden",
  "support.list.clearSelection": "Auswahl aufheben",
  "support.list.complete": "Erledigen",
  "support.list.done": "Erledigt",
  "support.list.empty": "Keine Nachrichten.",
  "support.list.followUpDue": "Nachfassen fällig",
  "support.list.messages": "Nachrichten",
  "support.list.open": "Offen",
  "support.list.partialSearchError":
    "Einige Filter konnten nicht geladen werden.",
  "support.list.reopen": "Wieder öffnen",
  "support.list.searchMessages": "Nachrichten suchen",
  "support.list.select": "Auswählen",
  "support.list.selectTicket": "{title} auswählen",
  "support.list.selectedCount": "{count} ausgewählt",
  "support.list.sort": "Nachrichten sortieren",
  "support.list.sortOverdue": "Über 24 Std. offen",
  "support.list.sortUnread": "Ungelesene zuerst",
  "support.list.sortUrgent": "Dringende zuerst",
  "support.list.ticketState": "Ticketstatus",
  "support.list.tryAnotherFilter": "Versuche einen anderen Filter.",
  "support.list.unreadCount": "{count} ungelesen",
  "support.list.urgent": "Dringend",
  "support.list.waitingFor": "Wartet seit {time}",
  "support.new.apartment": "Wohnung",
  "support.new.broadcast": "Rundnachricht",
  "support.new.broadcastRecipients":
    "{count} Empfänger · jede Person erhält die Nachricht einzeln",
  "support.new.channel": "Kanal",
  "support.new.description":
    "Eine neue Unterhaltung mit einem oder mehreren Kontakten beginnen.",
  "support.new.from": "Von",
  "support.new.message": "Nachricht",
  "support.new.noContact": "Kein Kontakt gefunden.",
  "support.new.property": "Objekt",
  "support.new.recipientCount": "{count} Empfänger",
  "support.new.recipients": "Empfänger",
  "support.new.room": "Zimmer",
  "support.new.searchContacts":
    "Name, Zimmer, Wohnung, Objekt, E-Mail oder Telefon",
  "support.new.sendFailed":
    "{count} Nachricht(en) konnten nicht gesendet werden.",
  "support.new.sending": "Wird gesendet …",
  "support.new.sent": "{count} Nachricht(en) gesendet.",
  "support.new.subject": "Betreff",
  "support.new.tenantCount": "{count} Mieter",
  "support.new.title": "Neue Nachricht",
  "support.new.writeMessage": "Nachricht schreiben …",
  "support.notes.mention": "Teammitglied erwähnen",
  "support.notes.placeholder": "Notiz fürs Team – {name} sieht das nicht",
  "support.notifications.empty": "Noch keine Zuweisungen oder Erwähnungen",
  "support.notifications.forYou": "Für dich",
  "support.notifications.markAllRead": "Alle als gelesen markieren",
  "support.notifications.markRead": "Als gelesen markieren",
  "support.preview.assignedArber": "Zuständig: Arber",
  "support.preview.openingMessage":
    "Hallo, ich habe leider ein Problem. Meine Heizung ist seit gestern Abend komplett kalt. Können Sie jemanden schicken?",
  "support.preview.photo": "Foto · Heizkörper-Thermostat",
  "support.preview.photoMessage": "Hier ein Foto vom Thermostat.",
  "support.preview.today": "Heute",
  "support.profile.noPayments": "Keine Zahlungen vorhanden.",
  "support.profile.noPreviousCases": "Keine früheren Fälle.",
  "support.profile.openFull": "Im Mieterbereich öffnen",
  "support.profile.paid": "bezahlt",
  "support.profile.payments": "ZAHLUNGEN",
  "support.profile.previousCases": "FRÜHERE FÄLLE",
  "support.profile.rent": "Miete",
  "support.rail.assigned": "Zuständig",
  "support.rail.inbox": "Posteingang",
  "support.rail.inboxes": "Posteingänge",
  "support.rail.more": "Weitere",
  "support.rail.navigation": "Support-Navigation",
  "support.rail.new": "Neu",
  "support.rail.newMessage": "Neue Nachricht",
  "support.rail.overdue": "Über 24 Std. offen",
  "support.rail.snoozed": "Wiedervorlage",
  "support.snooze.cancel": "Wiedervorlage aufheben",
  "support.snooze.custom": "Eigener Zeitpunkt",
  "support.snooze.friday": "Freitag",
  "support.snooze.future": "Bitte einen Zeitpunkt in der Zukunft wählen.",
  "support.snooze.later": "Später",
  "support.snooze.nextWeek": "Nächste Woche",
  "support.snooze.saveFailed": "Speichern fehlgeschlagen.",
  "support.snooze.set": "Setzen",
  "support.snooze.title": "Wiedervorlage",
  "support.snooze.today": "Später heute",
  "support.snooze.tomorrow": "Morgen früh",
  "support.translation.showOriginal": "Original zeigen",
  "support.translation.showTranslation": "Übersetzung zeigen",
  "support.translation.showingOriginal": "Original angezeigt",
  "support.translation.translatedFrom": "Übersetzt aus {language}",
  "support.unknown.banner": "Unbekannter Absender",
  "support.unknown.markExternal": "Als externen Kontakt markieren",
  "support.unknown.markFailed":
    "Dieser Absender konnte nicht als externer Kontakt markiert werden.",
};
